<div class="consent-methods-container">
  @if (useRadioButtons) {
    <!-- Radio Button Mode -->
    <mat-radio-group class="consent-method-radio-group" [value]="consentMethod()" (change)="onMethodChange($event.value)">
      @if (isMacAddressSupported()) {
        <mat-radio-button value="MAC_ADDRESS" class="consent-method-radio">
          MAC Address
        </mat-radio-button>
      }
      @if (isStripeSupported()) {
        <mat-radio-button value="STRIPE" class="consent-method-radio">
          Card Verification
        </mat-radio-button>
      }
      @if (isBillUploadSupported()) {
        <mat-radio-button value="BILL_UPLOAD" class="consent-method-radio">
          Bill Upload
        </mat-radio-button>
      }
    </mat-radio-group>
  } @else {
    <!-- Button Toggle Mode -->
    <mat-button-toggle-group [value]="consentMethod()" (change)="onMethodChange($event.value)">
      @if (isMacAddressSupported()) {
        <mat-button-toggle value="MAC_ADDRESS" aria-label="MAC Address">
          <mat-icon>settings_input_antenna</mat-icon>
          <span class="d-none d-md-inline ms-1">MAC Address</span>
        </mat-button-toggle>
      }
      @if (isStripeSupported()) {
        <mat-button-toggle value="STRIPE" aria-label="Card Verification">
          <mat-icon>credit_card</mat-icon>
          <span class="d-none d-md-inline ms-1">Card Verification</span>
        </mat-button-toggle>
      }
      @if (isBillUploadSupported()) {
        <mat-button-toggle value="BILL_UPLOAD" aria-label="Bill Upload">
          <mat-icon>receipt</mat-icon>
          <span class="d-none d-md-inline ms-1">Bill Upload</span>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  }
</div>

<div class="smart-consent-options">
  @if (consentMethod() === 'MAC_ADDRESS' && isMacAddressSupported()) {
    <div class="consent-option">
      <h6>MAC Address Verification</h6>
      <p>
        Please enter the <strong>last 4 digits</strong> of the MAC address (without any spaces or hyphens) from your In-Home Display (IHD).
      </p>

      <mat-expansion-panel class="expansion-panel" [expanded]="macGuideExpanded()" (opened)="macGuideExpanded.set(true)" (closed)="macGuideExpanded.set(false)">
        <mat-expansion-panel-header>
          <mat-panel-title class="primary-title">
            How to find the MAC Address?
          </mat-panel-title>
        </mat-expansion-panel-header>

        <p>
          A MAC number (also known as GUID or EUI number) consists of 16 digits with a mix of letters and numbers, that identifies your In-Home Display for your smart meter.
          Your In-Home Display may show the MAC/GUID/EUI number in different places:
        </p>

        <ul>
          <li>Bottom or back of device - it may be printed on a label along with a barcode.</li>
          <li>In the battery case - it may be printed on a label along with a barcode.</li>
          <li>Settings Menu - from the Home menu of your In-Home Display device, select Settings, then select Advanced. Select Device Information and the MAC/GUID/EUI number will be displayed.</li>
        </ul>
      </mat-expansion-panel>

      <mat-form-field appearance="fill">
        <mat-label>MAC Address</mat-label>
        <input matInput [formControl]="macAddressControl" placeholder="AB12" maxlength="4" (input)="onMacChanged()">
        <mat-hint>Last 4 digits of MAC Address</mat-hint>

        @if (macAddressControl.hasError('required') && macAddressControl.touched) {
          <mat-error>MAC Address is required</mat-error>
        }
        @if (macAddressControl.hasError('pattern') && macAddressControl.touched) {
          <mat-error>Please enter a valid 4 character alphanumeric MAC address (e.g., AB12)</mat-error>
        }
      </mat-form-field>
    </div>
  }

  @if (consentMethod() === 'BILL_UPLOAD' && isBillUploadSupported()) {
    <div class="consent-option">
      <h6>Energy Bill Upload</h6>
      <p>
        Upload a recent energy bill (PDF format) that shows your smart meter details. This will be used to verify your access to the property.
      </p>
      <div class="file-upload-section">
        <app-file-input #billUpload accept=".pdf" buttonLabel="Choose Energy Bill (PDF)"></app-file-input>
      </div>
    </div>
  }

  @if (consentMethod() === 'STRIPE' && isStripeSupported()) {
    <div class="consent-option">
      <h6>Credit/Debit Card Verification</h6>
      <p>
        We use your credit/debit card billing address to verify your identity and connection to the property.
        <strong>No card information is stored on our servers, and no charges will be made.</strong>
        Please ensure the card's billing address matches with the property address mentioned below.
      </p>

      <div class="property-address" *ngIf="propertyAddress()">
        <p>{{propertyAddress()}}</p>
      </div>

      <div class="stripe-section">
        @if (loadingStripeCredentialsSignal()) {
          <div class="loading-stripe">
            <p>Contacting stripe to initialize card verification...</p>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        } @else if (stripeInitializationFailedSignal()) {
          <div class="stripe-error">
            <p>Failed to initialize Stripe at the moment. Please try again later or try a different consent method</p>
            <div class="d-flex justify-content-center my-3"><button mat-flat-button (click)="resetStripe()">Retry</button></div>
          </div>
        } @else {
          <app-stripe-card [stripeElements]="stripeElements" [stripeCredentials]="stripeCredentialsSignal()" (change)="onStripeCardChange($event)"></app-stripe-card>
        }

        <!-- @if (isStripeCardValid()) {
          <div class="verification-success">
            <mat-icon class="icon-no-shrink">check_circle</mat-icon>
            <span>Card details are valid! Click 'Finish' to verify the address of this card</span>
          </div>
        } -->
      </div>
    </div>
  }
</div>
